import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import SetTitle from "../../utils/set_title";
import { BASE_URL, api } from "../../utils";
import Header from '../../components/Headers/Header'


export default function PEDFile() {
	SetTitle('PED Generation')
	const params = useParams()

	useEffect(() => {
		downloadData()
	}, [])

	const downloadData = () => {
		if (params?.id) {
			api.get('get-ped-generator/' + params.id, { responseType: 'blob' })
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					const contentDisposition = response.headers['content-disposition'];
					let fileName = 'ped_generator_file.xlsx';
					if (contentDisposition) {
						const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
						if (fileNameMatch.length === 2)
							fileName = fileNameMatch[1];
					}
					link.setAttribute('download', fileName);
					document.body.appendChild(link);
					link.click();
					link.remove();
					setTimeout(() => {
						window.location.href = '/ped-generator'
					}, 5000)
				})
				.catch((error) => {
					console.error("Download failed:", error);
					setTimeout(() => {
						window.location.href = '/ped-generator'
					}, 5000)
				});
		}
		else {
			setTimeout(() => {
				window.location.href = '/ped-generator'
			}, 1000)
		}
	}

	return (
		<Header
			iconClass="ni ni-folder-17 text-white"
			title="PED Generator"
			description="Download in corso..."
		/>
	)
}
